import { Auth } from '@or-sdk/auth';

import config from '../config';
import { authCookieDomain, authUiUrl, sdkApiUrl } from '../utils/authUiRuntime';

const getCookieValue = (name: string): string => {
  if (typeof document === 'undefined') {
    return '';
  }

  const cookie = document.cookie
    .split('; ')
    .find(item => item.startsWith(`${name}=`));

  return cookie ? decodeURIComponent(cookie.slice(name.length + 1)) : '';
};

export default new Auth({
  cookieDomain: authCookieDomain,
  cookiePrefix: config.COOKIE_NAME_PREFIX_NEW,
  allowGuestLogin: Boolean(config.GUEST_LOGIN),
  userCookieName: `${config.COOKIE_NAME_PREFIX}_name`,
  multiUserCookieName: `${config.COOKIE_NAME_PREFIX}_multi`,
  multiUserToken: () => getCookieValue(`${config.COOKIE_NAME_PREFIX}_multi`),
  userExpireCookieName: `${config.COOKIE_NAME_PREFIX}_user_expire`,
  expireInShort: +`${config.COOKIE_EXPIRATION_SHORT}`,
  expireInLong: +`${config.COOKIE_EXPIRATION_LONG}`,
  sdkUrl: sdkApiUrl,
  authUiUrl,
  allowIframe: Boolean(config.ALLOW_IFRAME),
});
